import React, { ChangeEvent, FC } from 'react';
import { Box, Typography, TextField } from '@mui/material';

interface ILastUserOnOrgProps {
  verificationValue: string;
  handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const LastUserOnOrg: FC<React.PropsWithChildren<ILastUserOnOrgProps>> = ({
  verificationValue,
  handleOnChange,
}) => {
  return (
    <Box
      display='flex'
      flexGrow={1}
      flexDirection='column'
      alignItems='center'
      width={'90%'}
      gap={1}>
      <Typography color='error' variant='body2'>
        You are the last user on the organization, leaving will delete this
        organization
      </Typography>
      <TextField
        required
        size='small'
        type='name'
        variant='outlined'
        label='Type "remove" to confirm'
        name='verificationValue'
        value={verificationValue}
        onChange={handleOnChange}
        fullWidth
      />
    </Box>
  );
};

export default LastUserOnOrg;
